import { createContext, ReactNode, useContext } from 'react';
import { SelectInput, SelectInputProps } from 'react-admin';
import Choice, { Choices } from '../../../common/Choice';
import { BLOCK_CONFIG } from '../BlocksInput';
import ContentTypeData from './ContentTypeData';

export const DEFAULT_CONTENT_TYPES: Choices = [
  { id: 'blocks', name: 'blocks', },
  { id: 'records', name: 'records', },
  { id: 'redirect', name: 'redirect', },
  { id: 'program', name: 'program', },
  { id: 'frontend_effect', name: 'frontend_effect', },
];

export type ProgramOption = Choice<{ blocks?: Array<BLOCK_CONFIG> }>
export type ProgramOptions = Choices<{ blocks?: Array<BLOCK_CONFIG> }>

interface Context {
  contentTypes: Choices,
  recordOptions: Choices,
  programOptions: ProgramOptions,
}

const DEFAULTCONTEXT: Context = {
  contentTypes: DEFAULT_CONTENT_TYPES,
  recordOptions: [],
  programOptions: [],
};

const ContentTypeContext = createContext<Context>(DEFAULTCONTEXT)

export const useContentTypeContext = () => useContext(ContentTypeContext);

interface ContentTypeProviderProps {
  contentTypes?: Choices,
  recordOptions: Choices,
  programOptions: Choices,
  children: ReactNode,
}

export const ContentTypeProvider = ({ children, contentTypes, recordOptions, programOptions, ...rest }: ContentTypeProviderProps) => {
  return (
    <ContentTypeContext.Provider value={{
      contentTypes: contentTypes ? contentTypes : DEFAULT_CONTENT_TYPES,
      recordOptions,
      programOptions
    }}>
      {children}
    </ContentTypeContext.Provider>
  )
}

export interface ContentTypeInputProps extends SelectInputProps {
  source: string,
}

const ContentTypeInput = ({ ...props }: ContentTypeInputProps) => {
  const { contentTypes } = useContentTypeContext();
  return (
    <>
      <SelectInput source={props.source} fullWidth choices={contentTypes} />
      <ContentTypeData {...props} />
    </>
  );
}

ContentTypeInput.defaultProps = {
}

export default ContentTypeInput;
